import { Reducer, AnyAction, Action } from 'redux';
import { ExternalUrlGroupsListState } from './types-store';
import {
  ACTION, ClearList,
  RequestList, ReceiveList, FailList,
  RequestDeleteExternalUrlGroup, ReceiveDeleteExternalUrlGroup, FailDeleteExternalUrlGroup
} from './action-types';

export const INITIAL_STATE: ExternalUrlGroupsListState = {
  requestId: 0,
  fetching: false,
  requestedSearchModel: undefined,
  numberOfResults: undefined,
  listItems: undefined,
  deletingExternalUrls: []
};

const reducers: { [indexer: string]: Reducer<ExternalUrlGroupsListState, Action> } = {

  [ACTION.CLEAR_LIST]: (state: ExternalUrlGroupsListState, action: ClearList): ExternalUrlGroupsListState => {
    return {
      ...state,
      requestId: action.requestId,
      fetching: false,
      requestedSearchModel: undefined,
      numberOfResults: undefined,
      listItems: undefined,
      deletingExternalUrls: []
    };
  },

  [ACTION.REQUEST_LIST]: (state: ExternalUrlGroupsListState, action: RequestList): ExternalUrlGroupsListState => {

    return {
      ...state,
      requestId: action.requestId,
      fetching: true,
      requestedSearchModel: action.model,
      ...(action.clearResults && {
        numberOfResults: undefined,
        listItems: undefined,
        deletingExternalUrls: []
      })
    };
  },

  [ACTION.RECEIVE_LIST]: (state: ExternalUrlGroupsListState, action: ReceiveList): ExternalUrlGroupsListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false,
      numberOfResults: action.numberOfResults,
      listItems: [
        ...(state.listItems || []),
        ...action.list
      ]
    };
  },

  [ACTION.FAIL_LIST]: (state: ExternalUrlGroupsListState, action: FailList): ExternalUrlGroupsListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false
    };
  },

  [ACTION.REQUEST_DELETE]: (state: ExternalUrlGroupsListState,
    action: RequestDeleteExternalUrlGroup): ExternalUrlGroupsListState => {

    return !state.deletingExternalUrls || !state.deletingExternalUrls.includes(action.id)
      ? {
        ...state,
        deletingExternalUrls: [
          ...(state.deletingExternalUrls || []),
          action.id
        ]
      }
      : state;
  },

  [ACTION.RECEIVE_DELETE]: (state: ExternalUrlGroupsListState,
    action: ReceiveDeleteExternalUrlGroup): ExternalUrlGroupsListState => {

    if (!state.deletingExternalUrls || !state.deletingExternalUrls.includes(action.id) || !state.listItems?.length) {
      return state;
    }

    const listItems = (state.listItems || []).filter(item => item.id !== action.id);

    return {
      ...state,
      listItems,
      numberOfResults: state.numberOfResults - (state.listItems.length - listItems.length),
      deletingExternalUrls: state.deletingExternalUrls.filter(id => id !== action.id)
    };
  },

  [ACTION.FAIL_DELETE]: (state: ExternalUrlGroupsListState,
    action: FailDeleteExternalUrlGroup): ExternalUrlGroupsListState => {

    return state.deletingExternalUrls && state.deletingExternalUrls.includes(action.id)
      ? {
        ...state,
        deletingExternalUrls: state.deletingExternalUrls.filter(id => id !== action.id)
      }
      : state;
  }
};

export const reducer: Reducer<ExternalUrlGroupsListState> = (
  state: ExternalUrlGroupsListState = INITIAL_STATE, action: AnyAction) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
